import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Lock, Scale } from 'lucide-react';
import { useAuth } from '../../App';
import { useMyAccess } from '../../hooks/useMyAccess';

export const LegalFormRequired = ({ children }) => {
  const { user, business, businessResolved } = useAuth();
  const { access } = useMyAccess();
  const navigate = useNavigate();
  const isBusiness = (user?.account_type || 'business') !== 'personal';
  const locked = isBusiness && businessResolved && !!business?.id && business.legal_form_confirmed !== true;
  if (!locked) return children;

  return (
    <div className="max-w-2xl mx-auto p-6 sm:p-10" data-testid="legal-form-locked">
      <Card className="border-[#283F8B]/20">
        <CardContent className="p-8 space-y-4">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-[#283F8B]/10 flex items-center justify-center"><Lock className="w-5 h-5 text-[#283F8B]" /></div>
            <div>
              <h2 className="text-lg font-semibold">Tax pages are locked</h2>
              <p className="text-sm text-muted-foreground">The legal form of {business?.business_name} has not been confirmed.</p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">
            Your legal form (sole trader, partnership, company, not-for-profit or branch) decides which taxes apply and at what rates.
            {access?.is_owner ? ' Confirm it to unlock the tax computation, compliance calendar and remittances.' : ' Ask the business owner to confirm it in Settings → General.'}
          </p>
          {access?.is_owner && (
            <Button onClick={() => navigate('/settings?tab=general')} className="bg-[#283F8B] hover:bg-[#1f3270]" data-testid="legal-form-locked-cta">
              <Scale className="w-4 h-4 mr-2" /> Confirm legal form
            </Button>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
